import { SVGProps } from 'react';

const CircleUser = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M7 20.662V19a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1.662M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10m-7-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
    />
  </svg>
);
export default CircleUser;
